// src/components/SelectShipToParty.js
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Container,
  Stack,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Divider,
  CircularProgress,
  Grid,
  useMediaQuery,
  Card,
  CardContent,
} from '@mui/material';
import {
  addManufacturerRoleToExistingFirmAction,
  getBuyerRolesAction,
} from '../Onboarding/auth/action';
import { useDispatch, useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import {
  getUserInventoryTransactionsStpInfoAction,
  searchCompanyAction,
} from '../../screen/distributor/action/util_action';
import { searchByTypes } from '../../utils/settings';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Row } from 'antd';
import SelectRoleModal from './SelectRoleModal';
import OnboardNowPrompt from './Components/OnboardNowPrompt';
import ScreenBackV2 from '../Components/ScreenBackV2';

export const RoleTab = ({
  display_name = '',
  onClick = () => {},
  selected = false,
}) => {
  return (
    <Button
      variant='outlined'
      sx={{
        color: selected ? '#F49D3F' : 'black',
        borderColor: selected ? '#F49D3F' : 'black',
      }}
      onClick={onClick}
    >
      {display_name}
    </Button>
  );
};

const SelectShipToParty = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [CompanyRoleData, setCompanyRoleData] = useState([]);
  const [influencerRoles, setInfluencerRoles] = useState([]);
  const [influencerRolesExists, setInfluencerRolesExists] = useState(false);
  const [influencerTabSelected, setInfluencerTabSelected] = useState(false);
  const [openSelectRolesPrompt, setOpenSelectRolesPrompt] = useState(false);
  const [promptDetails, setPromptDetails] = useState({});

  const [userType, setUserType] = useState({});
  const [allBuyers, setAllBuyers] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const IS_SELL_TO_BUYER = state?.fromFmcgCart || false;
  const [isLoadingAllBuyers, setIsLoadingAllBuyers] = useState(false);
  const [activeRadio, setActiveRadio] = useState(searchByTypes['PHONE']);
  const [enteredValue, setEnteredValue] = useState('');
  const [allFoundCompanies, setAllFoundCompanies] = useState([]);
  const [userNotFound, setUserNotFound] = useState(false);

  const {
    addedUserList,
    booking_details,
    isPaintFlow,
    seller_id,
    supplier_id,
    loginUser,
    noDownwardChain,
  } = useSelector((state) => {
    return {
      addedUserList: state.bcmOrderReducer.addedUserList,
      booking_details: state.bcmOrderReducer.booking_details,
      isPaintFlow: state.bcmOrderReducer.isPaintFlow,
      seller_id: state.bcmOrderReducer.seller_id,
      supplier_id: state.bcmOrderReducer.supplier_id,
      loginUser: state.loginReducer.loginUser,
      noDownwardChain: state.bcmOrderReducer.noDownwardChain,
    };
  });
  const [sellerID, setSellerID] = useState(
    booking_details?.seller_company_id || seller_id,
  );

  const getRoles = async () => {
    const params = new URLSearchParams();

    params.append('manufacturer_id', sellerID);
    params.append('is_ship_to_party', true);
    const { data, error, message } = await getBuyerRolesAction(
      sellerID,
      !IS_SELL_TO_BUYER,
      IS_SELL_TO_BUYER,
    );
    if (!error) {
      if (data.roles.length === 1 && data.roles[0].display_name === 'SELF') {
        dispatch({
          type: 'SET_NO_DOWNWARD_CHAIN',
          data: true,
        });
      } else {
        dispatch({
          type: 'SET_NO_DOWNWARD_CHAIN',
          data: false,
        });
      }

      const influencerRoles = data.roles.filter(({ region_role_id }) => {
        return region_role_id === null;
      });

      setInfluencerRolesExists(influencerRoles?.length > 0);
      setInfluencerRoles(influencerRoles);

      setCompanyRoleData(
        data.roles.filter(({ region_role_id }) => region_role_id !== null),
      );
    } else {
      return toast.error(message);
    }
  };

  useEffect(() => {
    getRoles();
  }, []);

  const getAggShilpkarDetailsByBuyer = async (userType) => {
    setIsLoadingAllBuyers(true);

    const payload = {
      firm_role_ids: influencerTabSelected
        ? influencerRoles.map((vv) => vv.firm_role_id)
        : [userType.firm_role_id],
      supplier_id: Number(sellerID),
    };

    const { data, error } = await getUserInventoryTransactionsStpInfoAction(
      payload,
    );
    setIsLoadingAllBuyers(false);
    if (!error) {
      setAllBuyers(
        data.map((vv) => ({
          ...vv,
          name: vv.company_name,
          value: vv.company_gstin_pan,
          phone_number: vv.company_phone_number,
        })),
      );
    }
  };

  const searchByPhone = Number(activeRadio) === searchByTypes['PHONE'];
  const searchByName = Number(activeRadio) === searchByTypes['NAME'];
  const searchByPan = Number(activeRadio) === searchByTypes['PAN'];
  const searchByGst = Number(activeRadio) === searchByTypes['GST'];

  useEffect(() => {
    if (!userType) return;
    getAggShilpkarDetailsByBuyer(userType);
  }, [userType]);

  const addUserToManufacturer = async (company_id, role) => {
    setOpenSelectRolesPrompt(false);
    setEnteredValue('');

    const payload = {
      manufacturer_id: role?.manufacturer_id || Number(sellerID),
      firm_role_id: role?.firm_role_id,
      region_role_map_id: role?.region_role_id,
      company_id: company_id,
    };

    const { data, error, message } =
      await addManufacturerRoleToExistingFirmAction(payload);

    if (!error) {
      setAllFoundCompanies([]);
      setEnteredValue('');

      return toast.success(message);
    } else {
      return toast.error(message);
    }
  };

  const searchUserByInfo = async (value, isExistingUser, selfRole) => {
    const payload = {
      supplier_id: Number(sellerID),
      firm_role_ids: influencerTabSelected
        ? influencerRoles.map((vv) => vv.firm_role_id)
        : [selfRole ? selfRole.firm_role_id : userType.firm_role_id],
    };

    if (isExistingUser) {
      payload.company_phone = value;
    } else {
      if (searchByPhone) payload.company_phone = value;
      if (searchByName) payload.company_name = value;
      if (searchByPan) payload.company_pan = value;
      if (searchByGst) payload.company_gstin = value;
    }

    const { data, error, message } = await searchCompanyAction(payload);

    if (!error) {
      if (
        data.length === 1 &&
        !data[0]?.onboarding_required &&
        isExistingUser
      ) {
        return setUser(data[0]);
      } else if (data.length === 1 && data[0]?.onboarding_required) {
        return toast.error(
          <OnboardNowPrompt message={data[0].prompted_message} />,
          {
            position: toast.POSITION.TOP_LEFT,
            autoClose: true, // Keep the toast open until closed manually
            closeButton: true,
            hideProgressBar: false,
            draggable: false,
            closeOnClick: false,
            style: {
              minWidth: '600px',
            },
          },
        );
      } else {
        setAllFoundCompanies(
          data.map((vv) => ({
            label: vv.name,
            value: vv.id,
            ...vv,
          })),
        );
      }
    } else return toast.error(message);
  };
  const debouncedSearch = useDebouncedCallback((value) => {
    searchUserByInfo(value);
  }, 500);

  const checkVCPClubbingLogic = (data) => {
    const { role_details, onboarding_required } = data;

    if (!role_details?.auto_create_mrm) {
      return setUser(data);
    }

    // Case 2: User Not Found  but Associated with Another Industry and Role details matched with the selected role
    else if (role_details?.auto_create_mrm && role_details?.firm_role_id) {
      return addUserToManufacturer(data?.id, role_details);
    }

    // Case 3: User Not Found but Associated with Another Industry and Role details not matched with the selected role
    else if (role_details?.auto_create_mrm && !role_details?.firm_role_id) {
      setPromptDetails(data);
      return setOpenSelectRolesPrompt(true);
    } else return toast.error(data.error_message);
  };
  const setUser = (data) => {
    const {
      geographic_info: {
        address_info,
        pincode_info,
        district_info,
        state_info,
        pricing_geography_info,
        location_info,
      },
    } = data;

    const userObj = {
      company_name: data.name,
      company_id: data.id,
      company_phone_no: data.phone_no,

      company_address1: address_info.address_line_1,
      company_address2: address_info.address_line_2,
      company_address3: address_info.address_line_3,

      company_pincode: pincode_info.pincode_id,
      district_id: district_info.district_id,
      location_id: location_info.location_id,
      location_name: location_info.location_name,
      pricing_geography_id: pricing_geography_info.pricing_geography_id,
      pricing_geography_name: pricing_geography_info.pricing_geography_name,
      state_id: state_info.state_id,
      pancard_no:
        data.gstin_pan && data.gstin_pan.length === 10 && data.gstin_pan,
      gstin: data.gstin_pan && data.gstin_pan.length === 15 && data.gstin_pan,
    };

    navigate('/order-booking/ship-to-party-details', {
      state: {
        buyerDetails: userObj,
        isFromEditOrderDetails: state?.isFromEditOrderDetails ? true : false,
        isSellToBuyer: IS_SELL_TO_BUYER,
      },
    });
  };

  const handleExistingShipToPartyClick = (row) => {
    searchUserByInfo(row.phone_number, true);
  };

  const notFoundAction = () => {
    return navigate('/onboard-buyer', {
      state: {
        isFromSearchStp: true,
      },
    });
  };

  return (
    <Container
      maxWidth='true'
      sx={{
        pl: '2rem',
        pt: '2rem',
        height: window.innerHeight,
        overflowY: 'auto',
        backgroundColor: '#f5f5f5',
      }}
    >
      <SelectRoleModal
        allInfluencerRoles={influencerRoles}
        visible={openSelectRolesPrompt}
        onClose={() => {
          setOpenSelectRolesPrompt(false);
          setEnteredValue('');
        }}
        promptDetails={promptDetails}
        onFinish={addUserToManufacturer}
      />
      <Stack
        direction={'row'}
        spacing={1}
        alignItems={'center'}
        sx={{ mb: '1rem' }}
      >
        <ScreenBackV2
          color={'black'}
          sxClr={'black'}
        />
        <Typography
          variant='h5'
          gutterBottom
          sx={{ fontWeight: 'bold' }}
        >
          Select Ship To Party
        </Typography>
      </Stack>

      <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
        <Typography
          variant='h6'
          gutterBottom
        >
          Select Ship To Party
        </Typography>
        <Grid
          spacing={2}
          container
        >
          {CompanyRoleData.map((role) => {
            return (
              <Grid item>
                <RoleTab
                  role={role}
                  display_name={role.display_name}
                  selected={role.firm_role_id === userType.firm_role_id}
                  onClick={() => {
                    setAllFoundCompanies([]);
                    setEnteredValue('');
                    if (role.display_name === 'SELF') {
                      searchUserByInfo(loginUser.phone_no, true, role);
                    } else {
                      setInfluencerTabSelected(false);
                      setUserType({
                        firm_role_id: role.firm_role_id,
                        firm_role_name: role.display_name,
                      });
                    }
                  }}
                />
              </Grid>
            );
          })}
          {influencerRolesExists && (
            <Grid item>
              <RoleTab
                display_name='Influencer'
                selected={influencerTabSelected}
                onClick={() => {
                  setInfluencerTabSelected(true);
                  setUserType({});
                }}
              />
            </Grid>
          )}
        </Grid>

        {!noDownwardChain &&
          (Object.keys(userType).length > 0 || influencerTabSelected) && (
            <>
              {' '}
              <Typography
                variant='h6'
                sx={{ marginTop: '2rem' }}
                gutterBottom
              >
                Search Ship To Party by
              </Typography>
              <FormControl>
                <RadioGroup
                  aria-labelledby='demo-radio-buttons-group-label'
                  defaultValue={searchByTypes['PHONE']}
                  name='radio-buttons-group'
                  row
                  onChange={(e) => {
                    setActiveRadio(e.target.value);
                    setAllFoundCompanies([]);
                    setEnteredValue('');
                  }}
                >
                  <FormControlLabel
                    value={searchByTypes['PHONE']}
                    control={<Radio />}
                    label='Phone'
                  />

                  {!influencerTabSelected && (
                    <>
                      <FormControlLabel
                        value={searchByTypes['NAME']}
                        control={<Radio />}
                        label='Name'
                      />
                      <FormControlLabel
                        value={searchByTypes['PAN']}
                        control={<Radio />}
                        label='PAN'
                      />
                      <FormControlLabel
                        value={searchByTypes['GST']}
                        control={<Radio />}
                        label='GST'
                      />
                    </>
                  )}
                </RadioGroup>
              </FormControl>
              <TextField
                fullWidth
                placeholder='Search by Phone/ Name/ Pan/ GST'
                variant='outlined'
                sx={{ mb: 3 }}
                value={enteredValue || ''}
                onChange={(e) => {
                  const value = e.target.value;
                  let regex;

                  if (searchByPhone) {
                    regex = /^[0-9]{0,10}$/;
                    if (value.length <= 10 && regex.test(value)) {
                      setEnteredValue(value);
                      if (value.length === 10) debouncedSearch(value);
                    }
                  } else if (searchByName) {
                    setEnteredValue(value);
                    if (value.length > 3) debouncedSearch(value);
                  } else if (searchByPan) {
                    regex = /^[a-zA-Z0-9]{0,10}$/;
                    if (value.length <= 10 && regex.test(value)) {
                      setEnteredValue(value);
                      if (value.length === 10) debouncedSearch(value);
                    }
                  } else if (searchByGst) {
                    regex = /^[a-zA-Z0-9]{0,15}$/;
                    if (value.length <= 15 && regex.test(value)) {
                      setEnteredValue(value);
                      if (value.length === 15) debouncedSearch(value);
                    }
                  } else {
                    setAllFoundCompanies([]);
                  }
                }}
              />
            </>
          )}

        {userNotFound && (
          <Row
            style={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              onClick={() => notFoundAction()}
              variant='contained'
            >
              Onboard Buyer
            </Button>
          </Row>
        )}

        {allFoundCompanies && allFoundCompanies.length > 0 && (
          <Box
            sx={{
              overflowY: 'scroll',
              height: '50vh',
            }}
          >
            {allFoundCompanies.map((user, index) => {
              return (
                <Card
                  onClick={() => checkVCPClubbingLogic(user)}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    p: 2,
                    my: 1,
                    cursor: 'pointer',
                    width: '100%',
                  }}
                >
                  <Typography>{user?.name}</Typography>
                  {user?.gstin_pan && (
                    <Typography>GST / PAN : {user?.gstin_pan}</Typography>
                  )}
                </Card>
              );
            })}
          </Box>
        )}
        {isLoadingAllBuyers ? (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            height={300}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            {allBuyers && allBuyers.length > 0 && (
              <Box sx={{ height: '50vh', overflowY: 'auto' }}>
                <Divider
                  sx={{
                    height: 2,
                    marginTop: '2rem',
                    marginBottom: '2rem',
                    fontWeight: 'bold',
                  }}
                />
                <Typography
                  variant='h6'
                  gutterBottom
                  sx={{}}
                >
                  Click on existing Ship to Party
                </Typography>
                {!isMobile ? (
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Firm Name</TableCell>
                          {!influencerTabSelected && (
                            <TableCell>GSTN / PAN</TableCell>
                          )}
                          <TableCell>Phone No.</TableCell>
                          {influencerTabSelected && <TableCell>Role</TableCell>}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {allBuyers.map((row, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              handleExistingShipToPartyClick(row);
                            }}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{row.name}</TableCell>
                            {!influencerTabSelected && (
                              <TableCell>{row?.value}</TableCell>
                            )}
                            <TableCell>{row.phone_number}</TableCell>
                            {influencerTabSelected && (
                              <TableCell>
                                {row?.role_details?.display_name}
                              </TableCell>
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Grid
                    container
                    spacing={2}
                    component={Paper}
                    sx={{ p: 0 }}
                  >
                    {allBuyers.map((row, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        key={index}
                        sx={{ p: 0 }}
                      >
                        <Card
                          sx={{
                            cursor: 'pointer',
                            boxShadow: 'none',
                            border: '1px solid #f5f5f5',
                            borderRadius: '10px',
                          }}
                          onClick={() => handleExistingShipToPartyClick(row)}
                        >
                          <CardContent>
                            <Typography
                              variant='h6'
                              sx={{ fontSize: '16px', fontWeight: 'bold' }}
                            >
                              {row.name}
                            </Typography>
                            {!influencerTabSelected && (
                              <Typography variant='body2'>
                                GSTN / PAN: {row?.value}
                              </Typography>
                            )}
                            <Typography variant='body2'>
                              Phone No.: {row.phone_number}
                            </Typography>
                            {influencerTabSelected && (
                              <Typography variant='body2'>
                                Role: {row?.role_details?.display_name}
                              </Typography>
                            )}
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </Box>
            )}
          </>
        )}
      </Paper>
    </Container>
  );
};

export default SelectShipToParty;
